import React, { useState } from 'react';
import classnames from 'classnames';

import validateImage from '../../utils/validate_image';
import { ReactComponent as ImageIcon } from '../../svg/image.svg';

import Dropzone from 'react-dropzone';

const ImageUploader = ({
    removable = true,
    replaceable = false,
    uploadText = '',
    filename = '',
    onChange = () => {},
    className = '',
    disabled = false,
    onRemove = () => {},
    onError = () => {},
    onPreDrop = () => {}
}) => {
    const [imageLoadError, setImageLoadError] = useState(false);

    const onDrop = (files) => {
        onPreDrop();
        validateImage(files[0], { width: 2400, aspect: 1 })
            .then((url) => {
                onChange(files[0], url);
            })
            .catch((e) => {
                e.context = {
                    file: files[0]
                };
                onError(e);
            });
    };

    const handleRemove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onRemove();
    };

    const handleImageError = () => {
        setImageLoadError(true);
    };

    const handleImageLoad = () => {
        setImageLoadError(false);
    };

    let hasImage = filename && !imageLoadError;
    return (
        <>
            {!removable && filename && (
                <div className="dropzone image-uploader has-image">
                    <img src={filename} alt="" />
                </div>
            )}
            {(removable || !filename) && (
                <Dropzone onDrop={onDrop} accept="image/*" multiple={false} disabled={disabled}>
                    {({ getRootProps, getInputProps }) => (
                        <div
                            {...getRootProps()}
                            className={classnames('dropzone image-uploader', className, {
                                'has-image': hasImage
                            })}
                        >
                            <input {...getInputProps()} />
                            <div className="default-content">
                                <ImageIcon width={50} height={50} className="text-muted mb-2" />
                                <p>{uploadText}</p>
                                {(!hasImage || replaceable) && (
                                    <button className="btn btn-sm btn-pill btn-primary btn-remove" type="button">
                                        {replaceable ? 'Replace Image' : 'Add image'}
                                    </button>
                                )}
                                {hasImage && removable && !replaceable && (
                                    <button
                                        className="btn btn-sm btn-pill btn-danger btn-remove"
                                        type="button"
                                        onClick={handleRemove}
                                    >
                                        Remove
                                    </button>
                                )}
                            </div>
                            {hasImage && (
                                <div className="iu-image">
                                    <img src={filename} alt="" onLoad={handleImageLoad} onError={handleImageError} />
                                </div>
                            )}
                        </div>
                    )}
                </Dropzone>
            )}
        </>
    );
};
export default ImageUploader;
